import React, { useState, useEffect } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import '../../../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
const RichTextInput = ({
  fileIndex,
  tagIndex,
  metaTag,
  handleInputChange,
  id,
  setShowModal,
  intl,
}) => {
  const toolbar = {
    options: ['inline', 'blockType', 'list', 'textAlign', 'link', 'history'],
    inline: {
      options: ['bold', 'italic', 'underline', 'strikethrough'],
    },
  };

  const getStateFromValue = () => {
    let editorState = EditorState.createEmpty();
    const contentBlock = htmlToDraft(metaTag.meta.userInput || '');
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      editorState = EditorState.createWithContent(contentState);
    }
    return editorState;
  };

  const [editorState, setEditorState] = useState(() => {
    return getStateFromValue();
  });

  const [isChangesMade, setIsChangesMade] = useState(false);

  const onEditorStateChange = (editorState) => {
    if (!isChangesMade) setIsChangesMade(true);
    setEditorState(editorState);
  };

  const saveChanges = () => {
    const val = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    if (handleInputChange) {
      handleInputChange(fileIndex, tagIndex, val);
    }
    setShowModal(false);
  };

  const discardChanges = () => {
    setShowModal(false);
  };

  return (
    <div className="photo-uploader__image-list-rich-text-container">
      {/* <div className="photo-uploader-padding"> */}
      <Editor
        toolbar={toolbar}
        wrapperClassName="photo-uploader-padding photo-uploader__image-list-rich-text-wrapper"
        onEditorStateChange={onEditorStateChange}
        editorState={editorState}
        editorClassName="photo-uploader__image-list-rich-text-editor"
      />
      {/* </div> */}
      <div className="photo-uploader__image-list-Modal-custom-footer">
        <div
          className={classNames(
            'photo-uploader-horizontal-line',
            'photo-uploader-margin-bottom'
          )}
        />
        <div>
          {isChangesMade && (
            <Button onClick={() => discardChanges()} className={'mg-right-5'}>
              {intl.formatMessage({
                id: 'general.cancel',
              })}
            </Button>
          )}
          <Button
            onClick={() => (isChangesMade ? saveChanges() : discardChanges())}
          >
            {intl.formatMessage({
              id: isChangesMade ? 'general.save' : 'general.close',
            })}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(RichTextInput);
